import { Controller } from "@hotwired/stimulus"

// Inspired by: https://htmldom.dev/create-resizable-split-views/

export default class extends Controller {
  static targets = ["left", "divider", "right", "rightArrow", "leftArrow"]

  initialize() {
    this.boundMouseDown = this.mouseDown.bind(this);
    this.boundMouseMove = this.mouseMove.bind(this);
    this.boundMouseUp = this.mouseUp.bind(this);
  }

  connect() {
    this.dividerTarget.addEventListener("mousedown", this.boundMouseDown);
    this.maximized = false;
  }

  disconnect() {
    this.dividerTarget.removeEventListener("mousedown", this.boundMouseDown);
  }

  mouseDown(e) {
    // Get the current mouse position
    this.x = e.clientX;
    this.y = e.clientY;
    this.leftWidth = this.leftTarget.getBoundingClientRect().width;
    this.rightWidth = this.rightTarget.getBoundingClientRect().width;

    document.body.classList.add("cursor-col-resize");

    this.leftTarget.style.userSelect = 'none';
    this.leftTarget.style.pointerEvents = 'none';

    this.rightTarget.style.userSelect = 'none';
    this.rightTarget.style.pointerEvents = 'none';

    // Attach the listeners to `document`
    document.addEventListener('mousemove', this.boundMouseMove);
    document.addEventListener('mouseup', this.boundMouseUp);
  }

  mouseMove(e) {
    // How far the mouse has been moved
    const dx = e.clientX - this.x;
    const dy = e.clientY - this.y;

    const newLeftWidth = (this.leftWidth + dx);
    this.leftTarget.style.width = `${newLeftWidth}px`;

    // No need to adjust the right side.  It's set to grow to fill the remaining space.
  };

  mouseUp(e) {
    // Remove the handlers of `mousemove` and `mouseup`
    document.removeEventListener('mousemove', this.boundMouseMove);
    document.removeEventListener('mouseup', this.boundMouseUp);

    this.leftTarget.style.removeProperty('user-select');
    this.leftTarget.style.removeProperty('pointer-events');

    this.rightTarget.style.removeProperty('user-select');
    this.rightTarget.style.removeProperty('pointer-events');

    document.body.classList.remove("cursor-col-resize");
  }

  toggle() {
    if (this.maximized) {
      this.leftTarget.style.width = `${this.initialLeftWidth}px`;
      this.leftArrowTarget.classList.add("hidden");
      this.rightArrowTarget.classList.remove("hidden");
      this.maximized = false;
    } else {
      this.initialLeftWidth = this.leftTarget.getBoundingClientRect().width;
      const newLeftWidth = 0.9 * this.element.getBoundingClientRect().width;
      this.leftTarget.style.width = `${newLeftWidth}px`;
      this.leftArrowTarget.classList.remove("hidden");
      this.rightArrowTarget.classList.add("hidden");
      this.maximized = true;
    }
  }
}